import { render, staticRenderFns } from "./LastSynchro.vue?vue&type=template&id=1787b87f&"
import script from "./LastSynchro.vue?vue&type=script&lang=js&"
export * from "./LastSynchro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports